<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
import { validRequired } from '@/common/elementValid.js';
import googleads from '@/backend/services/googleAds/googleAds.js';

import keywordFormList from './keywordFormList.vue';

function getFormData(_obj, vm) {
	let { attributes } = vm;
	let { list, sharedList } = attributes;
	return {
		nativeNegativeLevel: {
			label: '作为否定关键字添加到：',
			formType: 'sky-radio',
			value: 1,
			options: [
				{
					label: '广告组',
					value: 1,
				},
				{
					label: '广告系列',
					value: 2,
				},
				{
					label: '否定关键词列表',
					value: 3,
				},
			],
		},
		sharedResourceName: {
			formType: 'sky-select',
			value: '',
			placeholder: '选择否定关键词列表',
			options: sharedList,
			props: {
				label: 'name',
				value: 'resourceName',
			},
			inputStyle: {
				width: '300px',
			},
			rules: [validRequired('请选择否定关键词列表')],
			visable(vm) {
				return vm.formData.fields.nativeNegativeLevel.value == 3;
			},
		},
		list: {
			formType: keywordFormList,
			value: list || [],
			column: [
				{
					label: '排除搜索关键词',
					type: 'inputBox',
					bind: 'searchTermName',
				},
				{
					label: '广告系列',
					type: 'tooltip',
					bind: 'campaignName',
				},
				{
					label: '广告组',
					type: 'tooltip',
					bind: 'adGroupName',
				},
			],
		},
	};
}

async function submit(data) {
	let { attributes } = this;
	let { serviceId } = attributes;
	try {
		await googleads.excludeSearchKeyword(data, serviceId);
		this.$message.success('排除成功');
		this.$emit('confirm');
	} catch (error) {
		this.$emit('cancel');
	}
}

function cancel(self) {
	self.$emit('cancel');
}

async function onShowLoad(props) {
	let { serviceId, self } = props;
	let { data: sharedList } = await googleads.getSharedList(serviceId);

	self.excludeLoading = false;

	return {
		sharedList,
		...props,
	};
}

const componentForm = formPanelCreate(
	{
		getFormData,
		submit,
		cancel,
	},
	{
		subButton: '确认排除',
		labelPosition: 'top',
	}
);

export default formDialogCreate({
	name: 'excludeKeywordFormDialog',
	onShowLoad,
	componentForm,
});
</script>
